module.exports = __webpack_public_path__ + "assets/images/c1cf5afa5abf167e475d9aa1d2959fc1-loader.gif";